import BaseAPI from '../base'

function getRoomOrders() {
    return BaseAPI.sendGet(`queue/hotels/list`);
}

function acceptRoomOrder(id, waiting_time) {
    return BaseAPI.sendPost(`queue/hotels/accept`, {
        room_order_id: id,
        waiting_time
    });
}

function cancelRoomOrder(id, reason) {
    return BaseAPI.sendPost(`queue/hotels/cancel`, {
        room_order_id: id,
        reason
    });
}

function payRoomOrder(id) {
    return BaseAPI.sendPost(`queue/hotels/pay`, {
        room_order_id: id
    });
}

function closeRoomOrder(id, pay_method, discount) {
    return BaseAPI.sendPost(`queue/hotels/close`, {
        room_order_id: id,
        pay_method,
        discount
    });
}

export default {
    getRoomOrders,
    acceptRoomOrder,
    cancelRoomOrder,
    closeRoomOrder,
    payRoomOrder
}